import { request } from '@/lib/api'

/**
 * Сводка «Мой день» (`GET /my-day`).
 *
 * Задач и встреч здесь нет: их отдаёт `GET /tasks/my` (#79), и экран берёт их оттуда —
 * вторая выдача тех же строк разошлась бы с экраном «Мои задачи».
 */

/**
 * Статус блока: `forbidden` — нет права на источник (говорится словами, а не пустотой),
 * `no_employee` — у учётной записи нет карточки сотрудника, «моего» нет по устройству.
 */
export type SectionStatus = 'ok' | 'forbidden' | 'no_employee'

export interface Section<T> {
  status: SectionStatus
  items: T[]
  /** Сколько всего, а не только показанных. */
  total: number
}

/** Сделка, требующая внимания. `stuck` считает сервер — тот же признак, что на доске. */
export interface AttentionDeal {
  id: string
  number: string
  title: string
  counterpartyId: string | null
  counterpartyName: string | null
  stageName: string
  /** Место стадии среди открытых (с единицы) и их число — для «рисок» стадии. */
  stageOrder: number
  openStages: number
  amount: number
  currency: string
  stuck: boolean
  daysInStage: number
  maxDaysInStage: number | null
  noNextStep: boolean
  /** Последнее завершённое касание; нет — сделку не трогали ни разу. */
  lastTouchAt: string | null
}

export interface NewLead {
  id: string
  title: string
  companyName: string | null
  contactName: string | null
  source: string
  createdAt: string
}

/** Неоплаченный счёт. `daysOverdue` нет — срок не наступил, а не «ноль дней». */
export interface InvoiceRow {
  id: string
  number: string
  counterpartyId: string
  counterpartyName: string | null
  total: number
  outstanding: number
  currency: string
  dueOn: string | null
  daysOverdue?: number | null
}

export interface MyDayInvoices {
  status: SectionStatus
  overdue: InvoiceRow[]
  awaiting: InvoiceRow[]
  /** Просрочка по валютам: рубли с евро не складываются. */
  overdueTotals: { currency: string; amount: number }[]
}

export interface MyDay {
  hasEmployeeCard: boolean
  deals: Section<AttentionDeal>
  leads: Section<NewLead>
  invoices: MyDayInvoices
}

export function fetchMyDay(signal?: AbortSignal): Promise<MyDay> {
  return request<MyDay>('/my-day', { signal })
}
